import {reducerFactory} from '../../lib/asyncUtil'
import {TFA_ENROLLMENTS} from '../actionTypes'

export default reducerFactory(TFA_ENROLLMENTS)
